import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { createDialog } from '@blade-sxp/tools/utils/dialogControl';
import Loading from '@blade-sxp/tools/components/loading.vue';
import Empty from '@blade-sxp/tools/pages/one-n/components/empty.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { Status } from '@blade-sxp/tools/interfaces';
// import { ImgSource, OneToNForm, PorTraitInfo, SearchResult, Status } from '@blade-sxp/tools/interfaces';
import { getSearchResult } from '@blade-sxp/tools/apis';
import CompareDetail from '@blade-sxp/tools/components/compare-detail.vue';
let Result = class Result extends Vue {
    form;
    status;
    localStorageParam;
    Status = Status;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    folderImg = require('@blade-sxp/tools/assets/images/folder.svg'); // 引入方式替换
    personImg = require('@blade-sxp/tools/assets/images/person.svg');
    orderHighImg = require('@blade-sxp/tools/assets/images/orderHigh.svg');
    orderSelectionImg = require('@blade-sxp/tools/assets/images/orderSelection.svg');
    pagination = {
        page: 1,
        size: 20,
        total: 0,
        totalPage: 1,
    };
    currentIndex = 0; // 当前选中项
    sourceImage;
    list = [];
    order = 'score';
    get hasPre() {
        return !(this.pagination.page === 1 && this.currentIndex === 0);
    }
    get hasNext() {
        return !(this.pagination.page === this.pagination.totalPage && this.currentIndex === this.list.length - 1);
    }
    get handleModelData() {
        return {
            hasPre: this.hasPre,
            hasNext: this.hasNext,
            percent: (parseInt(String(Number(this.list[this.currentIndex].score) * 1000)) / 10).toFixed(1),
            firstImage: this.handleUserInfo(),
            secoundImage: {
                // 拼写错误
                name: this.list[this.currentIndex].name,
                value: this.list[this.currentIndex].imageUrl,
                imageLib: this.list[this.currentIndex].libName,
            },
        };
    }
    handleUserInfo() {
        if (this.sourceImage) {
            if (this.sourceImage.imageFeature) {
                return {
                    value: this.sourceImage.imageFeature.imageBase64,
                };
            }
            return {
                name: this.sourceImage.imageLib?.name,
                value: this.sourceImage.imageLib?.libImageUrl,
                imageLib: this.sourceImage.imageLib?.libName,
            };
        }
        return {};
    }
    handleCompareDetail(index) {
        this.currentIndex = index;
        createDialog(CompareDetail, {
            handleType: this.handleType,
            source: this.handleModelData,
        });
    }
    reset() {
        this.order = '';
    }
    handleChangeOrder(val) {
        this.order = val;
        this.getTargets();
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.pagination.page = 1;
        this.getTargets();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTargets();
    }
    async handleType(type) {
        if (type === 0) {
            if (this.currentIndex === 0) {
                // 本页第一个
                this.pagination.page = this.pagination.page - 1;
                await this.getTargets();
                this.currentIndex = this.list.length - 1; // 上一页最后一个
            }
            else {
                this.currentIndex--;
            }
        }
        else {
            if (this.currentIndex === this.list.length - 1) {
                // 本页最后一个
                this.pagination.page = this.pagination.page + 1;
                await this.getTargets();
                this.currentIndex = 0; // 下一页第一个
            }
            else {
                this.currentIndex++;
            }
        }
        return this.handleModelData;
    }
    async getTargets() {
        try {
            let routeData = {
                objectId: '',
                businessType: '',
                incidentType: '',
                taskId: '',
                featureValue: '',
                version: null,
            };
            if (this.localStorageParam) {
                const param = JSON.parse(this.localStorageParam);
                routeData.objectId = param.objectId;
                routeData.businessType = param.businessType;
                routeData.incidentType = param.incidentType;
                routeData.taskId = param.taskId;
                routeData.featureValue = param.featureValue;
                routeData.version = param.version;
            }
            const { sourceImage, libIdList, threshold } = this.form;
            const { page, size } = this.pagination;
            const form = {
                sourceImage: sourceImage.type === 0
                    ? {
                        imageLib: {
                            libImageUrl: sourceImage.value,
                            libName: sourceImage.libName,
                            name: sourceImage.name,
                            portraitId: sourceImage.portraitId,
                        },
                    }
                    : {
                        imageFeature: {
                            feature: {
                                featureType: routeData.version && !sourceImage.featureType ? 'face' : sourceImage.featureType,
                                featureValue: routeData.version && !sourceImage.featureType ? routeData.featureValue : sourceImage.featureValue,
                                version: routeData.version && !sourceImage.featureType ? routeData.version : sourceImage.version,
                            },
                            imageBase64: sourceImage.value,
                        },
                        objectId: routeData?.objectId && !sourceImage.featureType ? routeData?.objectId : null,
                        businessType: routeData?.businessType && !sourceImage.featureType ? routeData?.businessType : null,
                        incidentType: routeData?.incidentType && !sourceImage.featureType ? routeData.incidentType : null,
                        taskId: routeData?.taskId && !sourceImage.featureType ? routeData.taskId : null,
                    },
                libIdList,
                threshold: Number(threshold) / 100,
                page,
                size,
            };
            // 排序参数
            if (this.order) {
                form.pageOrderList = [{ orderField: this.order }];
            }
            const { pageList, searchPageRequest } = await getSearchResult(form);
            const { sourceImage: resourceImage } = searchPageRequest;
            this.list = pageList.list;
            this.sourceImage = resourceImage;
            this.pagination.page = pageList.page;
            this.pagination.size = pageList.size;
            this.pagination.total = pageList.total;
            this.pagination.totalPage = pageList.totalPage;
        }
        catch (err) {
            this.$message.error(err?.data?.error || `${this.$t('common.serverError')}`);
            // this.status = Status.Prepare;
        }
    }
    async search() {
        try {
            this.$emit('changeStatus', Status.Incompare);
            await this.getTargets();
            this.$emit('changeStatus', Status.Finish);
        }
        catch (err) {
            this.$message.error(err?.data?.error || `${this.$t('common.serverError')}`);
            this.$emit('changeStatus', Status.Init);
        }
    }
};
__decorate([
    Prop(Object)
], Result.prototype, "form", void 0);
__decorate([
    Prop(Number)
], Result.prototype, "status", void 0);
__decorate([
    Prop({ default: '' })
], Result.prototype, "localStorageParam", void 0);
Result = __decorate([
    Component({
        name: 'result',
        components: { Empty, Loading, BlurPicture },
        i18n: {
            messages: {
                en: {
                    similarity: 'Similarity:',
                    highToLow: 'Similarity from high to low',
                    selection: 'Order of portrait library selection',
                    total: 'Total {msg} Items',
                },
                zh: {
                    similarity: '相似度：',
                    highToLow: '按相似度由高至低',
                    selection: '按人像库选定顺序',
                    total: '总共 {msg} 条',
                },
            },
        },
    })
], Result);
export default Result;
